import { Center, Spinner, Text, VStack } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Layout } from "../../../../common/layout/Layout";
import { useGetSourcingEventQuery } from "../../../../autogen/bff-api";
import { EditPublicSourcingEventForm } from "./EditPublicSourcingEventForm";

export const EditPublicSourcingEvent = () => {
  const params = useParams();
  const { t } = useTranslation();

  const { data: event, isLoading, isError } = useGetSourcingEventQuery(
    params.eventId ? { eventId: params.eventId } : skipToken
  );

  if (!params.eventId) return <div>{t("404 event not found")}</div>;

  if (isLoading) {
    return (
      <Layout>
        <Center h="50vh">
          <Spinner size="xl" />
        </Center>
      </Layout>
    );
  }

  if (isError || !event) {
    return (
      <Layout>
        <Center h="50vh">
          <VStack>
            <Text>{t("Could not load event")}</Text>
          </VStack>
        </Center>
      </Layout>
    );
  }

  return <EditPublicSourcingEventForm eventId={event.id} event={event} />;
};
